import cx from "classnames";

const emptyAva2 = <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="15" cy="15" r="15" fill="white"/>
    <path d="M15 0C6.72 0 0 6.72 0 15C0 23.28 6.72 30 15 30C23.28 30 30 23.28 30 15C30 6.72 23.28 0 15 0ZM15 4.5C17.49 4.5 19.5 6.51 19.5 9C19.5 11.49 17.49 13.5 15 13.5C12.51 13.5 10.5 11.49 10.5 9C10.5 6.51 12.51 4.5 15 4.5ZM15 25.8C11.25 25.8 7.935 23.88 6 20.97C6.045 17.985 12 16.35 15 16.35C17.985 16.35 23.955 17.985 24 20.97C22.065 23.88 18.75 25.8 15 25.8Z" fill="#9DA3A7"/>
</svg>

const MessageContact = ({message, dateHtml, saveContact}) => {
    try {
        const jsonObject = typeof message.text === 'string' ? JSON.parse(message.text.replaceAll('False', 'false')) : message.text;
        const {contacts} = jsonObject;
        const contactsLength = contacts.length;
        let i = 0;
        return contacts.map(({name, phone, phones}) => {
            i++;
            const last = contactsLength === i;
            const phonesString = phones ? phones.map(item => item.phone).join(",") : phone;
            return <div key={`${name}${i}`}>
                <div className="i-chats-dialogue-content-message-contact">
                    <div className="i-chats-dialogue-content-message-contact-ava">
                        {emptyAva2}
                    </div>
                    <div>
                        <div className="i-chats-dialogue-content-message-contact-formatted_name">{name.formatted_name}</div>
                        <small className="i-chats-dialogue-content-message-contact-phones">{phonesString}</small>
                    </div>
                </div>
                {last && <div className="i-chats-dialogue-content-message-contact-date">
                    {dateHtml}
                </div>}
                <div className={cx("i-chats-dialogue-content-message-contact-save-wrapper", {'middle': !last})} >
                    <div className="i-chats-dialogue-content-message-contact-save-wrapper-button" onClick={() => {saveContact(name.formatted_name, phonesString)}}>
                        Save
                    </div>
                </div>
            </div>
        })
    } catch (err) {
        console.log(err)
        return <div className="i-chats-dialogue-content-message-text">
            <span>
                <span>{message.text}</span>
            </span>
            <span className="i-chats-dialogue-content-message-text-block"></span>
        </div>
    }
}

export default MessageContact;